export const CALL_FOLLOW_BUTTON_TOUCH_TARGET_CLASS = "min-h-[44px]";
